export default class Translyric {
  ext = 'lrc'
  nameExt = '_trans'
  type = 'lyricTrans'
  lyricAST = {
    songInfo: {
      trackName: ''
    }
  }

  constructor(trackName, lyricText) {
    this.lyricAST.songInfo.trackName = trackName
    this.lyricText = lyricText
  }
}
